
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { GlobalComponent } from "src/app/global-component";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { TimeLineType } from "src/app/core/enums/timeline-type-enum";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { OwnerEntityType } from "src/app/core/enums/owner-entity-type-enum";


export class TimelineListTableConfig extends TableConfigurationModel {


     constructor() {
        super();
        this.listTitle = "Recent Activity";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {
                dataFieldName: 'clientBase',
                title: 'Client',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 1,
                width: "160px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName'
            },
            {
                dataFieldName: 'timeSpent',
                title: 'Time Spent',
                sortable: new SortByValuesModel('timeSpent'),
                visible: 'true',
                order: 2,
                width: "90px",
                type: ColumnTypeEnum.TimeSpent

            },

            {
                dataFieldName: 'createdDate',
                title: 'Created Date',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "120px",
                type: ColumnTypeEnum.Date
            },
            {
                dataFieldName: 'owner',
                title: 'Created By',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 4,
                width: "160px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName'
            },
            {
                dataFieldName: 'type',
                title: 'Type',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 5,
                width: "60px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: undefined,
                    switchOptions: [
                        { case: undefined, return: '' }
                    ]
                },
                customStatusText: {
                    type: undefined,
                    switchOptions: [
                        { case: TimeLineType.Note, return: $localize`:@@:Note` },
                        { case: TimeLineType.Email, return: $localize`:@@:Email` },
                        { case: TimeLineType.Event, return: $localize`:@@:Event` },
                        { case: undefined, return: $localize`:@@:Other` },
                    ]
                }
            },
            {
                dataFieldName: 'name',
                title: 'Title',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 6,
                width: "375px",
                type: ColumnTypeEnum.String,
                subDataFieldName: 'name',
            },

            {
                dataFieldName: 'description',
                title: 'Description',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 7,
                width: "375px",
                type: ColumnTypeEnum.String,
            },

            {
                title: 'Actions',
                visible: 'true',
                order: 8,
                width: "100px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = [

            {
                label: "ownerEntityType",
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Select Owner Type`, undefined, undefined, true),
                    new NgSelectListModel(OwnerEntityType.Client, $localize`:@@:Client`, undefined),
                    new NgSelectListModel(OwnerEntityType.Contact, $localize`:@@:Contact`, undefined,),
                    new NgSelectListModel(OwnerEntityType.Requisition, $localize`:@@:Requisition`, undefined,),
                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            },
            {
                label: "type",
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Select Type`, undefined, undefined, true),
                    new NgSelectListModel(TimeLineType.Note, $localize`:@@:Note`, undefined),
                    new NgSelectListModel(TimeLineType.Email, $localize`:@@:Email`, undefined,),
                    new NgSelectListModel(TimeLineType.Event, $localize`:@@:Event`, undefined,),
                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            }
        ]

        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search by description or creator name"
        }

        this.actions = [
            {
                visible: SecurityOperations.timeLine.timeLineRead,
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: false,
                inList: true
            },
            {
                visible: SecurityOperations.timeLine.timeLineCreateNote,
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: false
            },

        ]
        this.buttons = [
            {
                visible: SecurityOperations.timeLine.timeLineCreateNote,
                label: "Create New",
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                iconIsAfterLabel: false,
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default,
            },
        ]
    }
}